import styles from '../ImpliedClosingFees/styles';

export default {
  description: styles.description,
};
